import {useCallback, useState} from "react";

export const server = {
    Prod: "https://api.notaire-langloys.com",
    Test: "https://cors-anywhere.herokuapp.com/http://localhost:8080",
    Dev: "https://langloyscalc.azurewebsites.net"
};
const currentServer = server.Prod;
export const API_BASE_URL = currentServer;
export const PARTNER_JWT = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdXRob3JpemVkIjp0cnVlLCJ1c2VyX2lkIjoxNzg2OX0.uiKo9DU7E0JJhjVaRQqIXNADh2QbSC_sRQ2yonKLiw4"
export const ENABLE_REDUX_LOGGER = false;
export const DEACTIVATED_SIMULATEURS = [55, 56, 109, 110];

export function useForceUpdate() {
    const [, setTick] = useState(0);
    const update = useCallback(() => {
        setTick((tick) => tick + 1);
    }, []);
    return update;
}

export default {};

